import { Button } from "components/atoms";
import { useTranslation } from "react-i18next";

const ShowFound = ({ data: { found = [], notFound = [] }, process, prefix }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={`${prefix}__showfound`}>
        <div>
          <div>{notFound?.length ?? 0 }</div>
          <div>{t("module:phototool.fetchPc9.modal.create")}</div>
        </div>
        <div>
          <div>{found?.length ?? 0 }</div>
          <div>{t("module:phototool.fetchPc9.modal.update")}</div>
        </div>
      </div>
      <div className={`${prefix}__buttons`}>
        <span></span>
        <div>
          <Button
            content={`Agregar (${notFound?.length ?? 0}) y actualizar (${found?.length ?? 0})`}
            onClick={() => process({ add: true, update: true})}
            sm
            type="purple"
          />
          <Button
            content={`Sólo agregar (${notFound?.length ?? 0})`}
            disabled={!notFound?.length}
            onClick={() => process({ add: true, update: false})}
            sm
            type="purple"
          />
        </div>
      </div>
    </>
  );
};

export default ShowFound;
